/**
 * Module: ui
 * General ui behaviors
 * 
 * @package mindgrub-starter-theme
 */

const utils = require("./utilities");

/**
 * Initialize ui behaviors.
 */
function init() {
	const $sel = cacheSelectors();
	// Toggle active state.
	$( '[data-toggle-active]' ).on(
		'click',
		function(e) {
			e.preventDefault();
			var target = $( this ).data( 'toggle-active' );
			$( this ).toggleClass( 'active' );
			$( target ).toggleClass( 'active' );
		}
	);

	// Smooth scroll.
	$( '.js-scroll[href*="#"]:not([href="#"])' ).click(
		function() {
			if (location.pathname.replace( /^\//,'' ) == this.pathname.replace( /^\//,'' ) && location.hostname == this.hostname) {
				var target = $( this.hash );
				target     = target.length ? target : $( '[name=' + this.hash.slice( 1 ) + ']' );
				if (target.length) {
					$( 'html, body' ).animate(
						{
							scrollTop: target.offset().top
						},
						1000
					);
					return false;
				}
			}
		}
	);

	$sel.$logout.on('click', function() {
		if(!utils.form.isProcessing) {
			utils.form.isProcessing = true;
			loader.show();
			const post = $.post('/wp-json/alterwood/v1/logout');
			post.done((res) => {
				console.log(res);
				if (res.status === 'success') {
					window.location.href = res.redirect;
				} else {
					utils.form.isProcessing = false;
					loader.hide();
				}
			});
		}
	});

	$sel.$token.on('keypress', function(e) {
		const reg = /\w/g;
		const inputChar = String.fromCharCode(e.which);

		e.preventDefault();

		if (reg.test(inputChar) && ($(this).val().length < 6)) {
			$(this).val($(this).val() + inputChar);
		}
	});

	$sel.$token.on('focusin', function() {
		tokenInterval = setInterval(function(){
			$(this).scrollLeft(0);
		}.bind(this), 1);
	}).on('focusout', function() {
		clearInterval(tokenInterval);
	});

	$('.modal__open').on('click', function() {
		modal.show($($(this).data('modal')));
	});

	$sel.$modalClose.on('click', modal.hide);
	$sel.$overlay.on('click', modal.hide);

	function cacheSelectors() {
		return {
			$modal: $('.modal'),
			$overlay: $('.overlay'),
			$logout: $('.logout'),
			$modalClose: $('.modal__close'),
			$token: $('.token'),
		};
	};
	let tokenInterval = false;
};
const modal = {
	show: function($el = $('.modal')) {
		this.hide();
		$el.show().focus();
		$('.overlay').show()
		$('body').css('overflow', 'hidden');
	},
	hide: function() {
		$('.modal').hide();
		$('.overlay').hide();
		$('body').css('overflow', '');
	}
};
const loader = {
	show: function($el = $('body')) {
		if($el.length) {
			const $loader = '<div id="preloader" class="-absolute"><div id="loader"></div></div>';
			$el.append($loader);
		}
		else {
			const $loader = '<div id="preloader"><div id="loader"></div></div>';
			$('body').append($loader).css('overflow', 'hidden');
		}
	},
	hide: function() {
		$('#preloader').remove();
		$('body').css('overflow', '');
	}
};

/**
 * Public API
 *
 * @type {Object}
 */
module.exports = {
	init: init,
	modal: modal,
	loader: loader
};



// WEBPACK FOOTER //
// ./scripts/components/ui.js